module.exports = __webpack_public_path__ + "img/about-top-img.31254396.jpg";